import { styled } from '@mui/material';
import { fontFamily, weights } from '../context/CerebroThemeProvider';

type TextareaProps = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
	error?: boolean;
	success?: boolean;
};

const Textarea: React.FC<TextareaProps> = props => <textarea {...props} />;

export const CerebroTextarea = styled(Textarea, { shouldForwardProp: prop => prop !== 'error' && prop !== 'success' })(
	({ error = false, success = false, disabled, readOnly, theme }) => ({
		borderWidth: 2,
		borderStyle: 'solid',
		borderRadius: theme.shape.borderRadius,
		borderColor: error
			? theme.palette.error.main
			: disabled || readOnly
			? theme.palette.gray.light
			: theme.palette.gray.medium,

		color: disabled ? theme.palette.gray.light : theme.palette.gray.dark,
		cursor: disabled ? 'not-allowed' : 'initial',

		fontFamily,
		fontSize: 12,
		fontWeight: disabled ? weights.medium : weights.semibold,

		lineHeight: '14px',
		marginBottom: theme.spacing(1),
		marginTop: theme.spacing(1.5),
		padding: '14px 12px',

		outline: 'none',
		width: '100%',

		'&:focus:not(:read-only)': {
			borderColor: error
				? theme.palette.error.light
				: success
				? theme.palette.success.light
				: theme.palette.primary.main,
		},

		'&::placeholder': {
			color: theme.palette.gray.medium,
		},
	})
);
